import { Staking } from "@airdao/bond-periphery/core/contracts/types";
import { ContractNames, Contracts } from "@airdao/bond-periphery/core";
import { AddressLike, BigNumberish, ZeroAddress } from "ethers";

export async function Lock(contracts: Contracts, ContractName: ContractNames = ContractNames.Staking, token: AddressLike, amount: BigNumberish) {
  const staking = contracts.getContractByName(ContractName) as unknown as Staking;

  // Approve if needed
  // if (token) {
  //   const [signer] = await ethers.getSigners();
  //   const tokenContract = ERC20__factory.connect(token.toString(), signer);
  //   await tokenContract.approve(await staking.getAddress(), amount);
  // }
  return await staking.lock(token, amount, {
    value: token === ZeroAddress ? amount : 0,
  });
}

export async function LockETH(contracts: Contracts, ContractName: ContractNames = ContractNames.Staking, amount: BigNumberish) {
  return await Lock(contracts, ContractName, ZeroAddress, amount);
}

export async function Unlock(contracts: Contracts, ContractName: ContractNames = ContractNames.Staking, token: AddressLike, amount: BigNumberish) {
  const staking = contracts.getContractByName(ContractName) as unknown as Staking;
  return await staking.unlock(token, amount);
}

export async function UnlockETH(contracts: Contracts, ContractName: ContractNames = ContractNames.Staking, amount: BigNumberish) {
  return await Unlock(contracts, ContractName, ZeroAddress, amount);
}

export const UserMethods = {
  LockETH,
  UnlockETH,
  Lock,
  Unlock,
};

export default UserMethods;